// 生成图片的函数
export const generateImage = async (prompt, params) => {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) urlParams.append(key, value);
  });

  const encodedPrompt = encodeURIComponent(prompt);
  return `https://image.pollinations.ai/prompt/${encodedPrompt}?${urlParams.toString()}`;
};

// 生成文件名的函数
const generateFileName = (prompt) => {
  const now = new Date();
  const dateStr = now.toISOString().replace(/[:.]/g, '-').slice(0, 19);
  // 从提示词中提取关键字（最多取前20个字符）
  const promptKeyword = prompt.split(',')[0].slice(0, 20).trim().replace(/[^\w\u4e00-\u9fa5]/g, '_');
  return `AI_Art_${promptKeyword}_${dateStr}.png`;
};

// 检测是否在微信浏览器中
export const isWeixinBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};

// 获取代理图片URL的函数
export const getProxyImageUrl = (imageId) => {
  return `/api/images/${imageId}`;
};

// 下载图片的函数
export const downloadImage = async (imageUrl, prompt = '') => {
  try {
    // 生成文件名
    const filename = generateFileName(prompt);

    // 如果是在微信浏览器中
    if (isWeixinBrowser()) {
      // 创建一个模态框来显示图片
      const modal = document.createElement('div');
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      `;

      const img = document.createElement('img');
      img.src = imageUrl;
      img.style.cssText = `
        max-width: 90%;
        max-height: 70vh;
        object-fit: contain;
        border-radius: 8px;
        margin-bottom: 20px;
      `;

      const text = document.createElement('p');
      text.textContent = '长按图片保存';
      text.style.cssText = `
        color: white;
        font-size: 16px;
        margin-top: 16px;
      `;

      const closeButton = document.createElement('button');
      closeButton.textContent = '关闭';
      closeButton.style.cssText = `
        background: #3B82F6;
        color: white;
        border: none;
        padding: 8px 24px;
        border-radius: 6px;
        font-size: 14px;
        margin-top: 16px;
        cursor: pointer;
      `;

      closeButton.onclick = () => {
        document.body.removeChild(modal);
      };

      modal.onclick = (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal);
        }
      };

      modal.appendChild(img);
      modal.appendChild(text);
      modal.appendChild(closeButton);
      document.body.appendChild(modal);
    } else {
      // 非微信浏览器使用普通下载方式
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  } catch (error) {
    console.error('下载图片失败:', error);
    throw error;
  }
};
